<!-- ================:=========================================================================
  File Name: EditGroup.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="group-new">

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <group-details-tab :data="group_data" v-on:update_group_data="groupDataUpdate" v-on:insert_group_data="createGroup"/>
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import GroupDetailsTab     from './GroupDetailsTab.vue'

export default {
  components: {
    GroupDetailsTab
  },
  data () {
    return {
      group_data: {
        group_name: undefined,
        group_description: undefined,
        group_color: undefined,
        group_status: undefined
      },

      activeTab: 0
    }
  },
  watch: {
    activeTab () {
    //tab change
    }
  },
  methods: {
    groupDataUpdate (data) {
      this.group_data = data
    },
    createGroup () {

      const pl = {
        name: this.group_data.group_name,
        description: this.group_data.group_description,
        color: this.group_data.group_color === undefined ? '#00B5FF' : this.group_data.group_color,
        status: this.group_data.group_status === undefined ? 'active' : this.group_data.group_status

      }

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to create group',
          text: 'Please provide a Group Name',
          color: 'danger',
          position: 'top-right'
        })
      }


      this.$vs.loading()

      this.$http.post('groups/create', pl)
        .then(response => {
          this.$vs.loading.close()

          this.$vs.notify({
            title: 'Created group successfully',
            text: `New local group ${pl.name} has been created.`,
            color: 'success',
            position: 'top-right'
          })

          if (response.status === 200) {
            const data = response.data.data
            this.$router.push(`/a/groups/${data.id}`)
          }

        })
        .catch(exception => {

          let error = 'An unknown error occurred while creating this group'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to create group',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  }
}

</script>
